//
// Copyright (c) 2011-2022 by Curalate, Inc.
//

import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { Modal, ModalBody, ModalHeader } from 'unison';

import ActionButton from '@components/atoms/action-button/ActionButton';
import { TitleText } from '@components/atoms/text/Text';
import { actions as streamDrawerActions } from '@streams/actions/streamDrawerActions';
import AutoApprovalFields from '@streams/components/AutoApprovalFields';
import { AUTO_FILTERS } from '@streams/constants/streamCreationConstants';

const AutoApprovalModal = () => {
  const dispatch = useDispatch();

  return (
    <AutoApprovalModalWrapper isOpen={true}>
      <AutoApprovalModalHeader>
        <TitleTextWrapper>Auto Distribute</TitleTextWrapper>
        <ActionButton
          iconName='close'
          onClick={() => {
            dispatch(streamDrawerActions.closeAutoApprovalModal());
            dispatch(streamDrawerActions.closeAutoApprovalEntryModal());
          }}
        ></ActionButton>
      </AutoApprovalModalHeader>
      <AutoApprovalModalBody>
        <AutoApprovalFields showOnlyActiveField={false}></AutoApprovalFields>
      </AutoApprovalModalBody>
    </AutoApprovalModalWrapper>
  );
};

const AutoApprovalModalWrapper = styled(Modal)`
  width: ${AUTO_FILTERS.containerWidth}px;
  height: ${AUTO_FILTERS.containerHeight}px;
`;

const AutoApprovalModalHeader = styled(ModalHeader)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const TitleTextWrapper = styled(TitleText)`
  font-size: 24px;
`;
const AutoApprovalModalBody = styled(ModalBody)`
  padding: 10px;
  height: 300px;
  overflow: scroll;
`;

export default AutoApprovalModal;
